/**
* @ClassName: JsBridge
* @Description: JS 掉 native封装 
*               Android webview 桥接 ifram方式
*               Ios uiwebview 桥接 ifram方式
*               Ios wkwebview 桥接 messageHandlers方式
* @author june
*
*/
class JsBridge {
    /**
     *
     * * constructor 
     * 
     *    @ua        string  : userAgent信息
     *    @ios       boolean : 判断ios
     *    @wkwebview boolean : 判断wkwebview
     *    @options   object  : 桥接所需参数
     * 
     * */
    constructor(){
        this.ua         = navigator.userAgent.toLowerCase();
        this.ios        = /(iphone|ipod|ipad)/i.test(this.ua);

        this.wkwebview  = this.isWkwebview();
        this.debugswitch= 'off'; 
        // this.callbackid = 0; //native调用jscallback函数名每次加1；(因多个jsbridg存在互斥关系而改用全局变量)
        this.setCallbackId();
        this.options    = {};
    }
    setCallbackId(){
        if (!window.nativecallback_id) {
            window.nativecallback_id = 0;
        }
    }
    //判断wk环境
    isWkwebview(){
        /*
        * wk迭代版本中出现累加多个页面的ua情况，原先包含webview/wk的判断失效。异常ua表现如下
        *   User-Agent: 
        *    Kuaikan/5.66.0/566000(iPhone;iOS 13.3;Scale/3.00;WiFi;2436*1125) webview/ui 
        *    Kuaikan/5.66.0/566000(iPhone;iOS 13.3;Scale/3.00;WiFi;2436*1125) webview/wk 
        *    Mozilla/5.0 (iPhone; CPU iPhone OS 13_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148  kdtUnion_8a6399314b6c8fd133
        * 第一行才是正确的webview-ua标示，因而有了下面逻辑判断。客户端已知问题在计划567000版本修复
        */
        let ua      = navigator.userAgent.toLowerCase();
        let indexUi = ua.indexOf('webview/ui');
        let indexWk = ua.indexOf('webview/wk');
        if (indexWk == -1) return false;
        if (indexUi == -1) return true;
        if (indexUi < indexWk) return false;
        return true;
    }
    //桥接ios&android - webview
    bridgeWebview() {
        if (this.ios) {
            this.bridgeIosWebview()
        } else {
            this.bridgeAndroidWebview();
        }
    }
      
    //桥接ios - webview
    bridgeIosWebview(){
        if (this.options.schema == 'window') {
            this.interworkingWindow();
        } else if (this.wkwebview) {
           this.interworkingMessageHandler();
        } else { //uiwebview
           this.interworkingIfram();
        }
    }
 
    //桥接android - webview
    bridgeAndroidWebview(){
        if (this.options.schema == 'window') {
            this.interworkingWindow();
        } else if (this.options.schema == 'kkmh') {
            this.interworkingKkmh();
        } else {
            this.interworkingIfram();
        }
        
    }
 
    /**
     * * interworkingWindow : 互通方式：native 主动调用 js function
     * 参数
     * options={
     *    @schema       : 'window',             //string : kkmhhybrid, kkhybrid, kkaction, kkmh, window...
     *    @tagname      : 'recivefreecardinfo', //string : 方法名称
     * }
     *
     * 返回:无
     * **/
    interworkingWindow(){
        let { schema, tagname, callback, is_del_nativecallback } = this.options;
        let callbackname = tagname;
        window[callbackname] = (res) => {
            typeof callback === 'function' && callback(res, callbackname);
            if (is_del_nativecallback && callbackname) {
                delete window[callbackname];
            }
        }
        this.debug('js注册函数:',`${schema}.${tagname}`);
    }

    /**
     * * interworkingKkmh : 互通方式：kkmh注入 - android下一种方式
     * 参数
     * options={
     *    @schema       : 'kkmh',               //string : kkmhhybrid, kkhybrid, kkaction, kkmh, window...
     *    @tagname      : 'saveJpegImageBase64',//string : 方法名称
     *    @callback     : function,             //string : 业务回调函数，收到native结果通过此函数传递结果
     *    @param        : {                     //object : 参数，固定key value为传递到方法名的参数
     *         value : ''
     *    },             
     * }
     *
     * 返回:无
     * **/
    interworkingKkmh(){
        let { schema, tagname, param, callback } = this.options;
        let res = window[schema] && window[schema][tagname] ? window[schema][tagname](param.value) : `not found ${schema}.${tagname}`;
        
        typeof callback === 'function' && callback(res);
        this.debug('js注入模式:',`${schema}.${tagname}(${param.value})`);
    }

    /**
     * * interworkingIfram : 互通方式：ifram假跳转
     * 参数
     * options={
     *    @schema       : 'kkmhhybrid', //string : kkmhhybrid, kkhybrid, kkaction, kkmh, window...
     *    @tagname      : 'login',      //string : 方法名称
     *    @param        : {},           //object : 参数
     * }
     *
     * 返回:无
     * **/
    interworkingIfram(){
        let { schema, tagname, param } = this.options;
        let params = {};
        if (schema === 'kkaction' && tagname !== 'share') { 
            params = JSON.parse(JSON.stringify(param));
        } else {
            if (JSON.stringify(param) !== '{}') {
                params.param = encodeURIComponent(JSON.stringify(param));
            }
        }
        let callbackname = this.registCallbackFn();  
        let query   = this.paramToQuery(params,callbackname);
        let src     = `${schema}://${tagname}${query ? '?'+query : ''}`;
        this.debug('假请求模式:',src);

        //创建ifram
        let iframe           = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src           = src;
        document.documentElement.appendChild(iframe);
        setTimeout(() => { document.documentElement.removeChild(iframe) }, 0)
    }
 
    /**
     * * interworkingMessageHandler : 互通方式：MessageHandler注入 - wkwebview方式
     * 参数
     * options={
     *    @schema       : 'kkmhhybrid', //string : kkmhhybrid, kkhybrid, kkaction, kkmh, window...
     *    @tagname      : 'login',      //string : 方法名称
     *    @param        : {},           //object : 参数
     * }
     *
     * 返回:无
     * **/
    interworkingMessageHandler(){
        let { schema, tagname, param } = this.options;
        let callbackname = this.registCallbackFn();
        let msg = {
            schema      : schema,
            tagname     : tagname,
            param       : param,
            callback    : callbackname, //正常callback
            callBack    : callbackname  //kkaction协议几乎都是大写 getSysDeviceInfo/getLoginInfo...
        }
        
        this.debug('js注入模式:',msg);
        try {
            window.webkit.messageHandlers.kkHybridBridge.postMessage(msg);
        } catch (error) {
            console.log(error);
        }
    }
 
    /**
     * * formatOptions : 格式化属性
     * 参数
     * options={
     *    @schema       : 'kkmhhybrid', //string  : kkmhhybrid, kkhybrid, kkaction, kkmh, window...
     *    @tagname      : 'login',      //string  : 方法名称
     *    @callback     : function,     //string  : 业务回调函数，收到native结果通过此函数传递结果
     *    @param        : {},           //object  : 参数 
     *    @is_del_nativecallback: true, //boolean : 删除客户端回调函数是指，删除接收客户端返回结果的函数
     *    @debug        : true,         //boolean : 不传递默认为false
     * }
     *
     * 返回: 检查数据类型返回
     * {
     *    @schema       : 'kkmhhybrid', //string  : kkmhhybrid, kkhybrid, kkaction, kkmh, window...
     *    @tagname      : 'login',      //string  : 方法名称
     *    @callback     : function,     //string  : 业务回调函数，收到native结果通过此函数传递结果
     *    @is_del_nativecallback: true, //boolean : 删除客户端回调函数是指，删除接收客户端返回结果的函数
     *    @param        : {},           //object  : 参数
     * }
     * */
    formatOptions({ schema='', tagname='', param={} , callback='', is_del_nativecallback=true, debug=false } = {}){
        this.debugswitch = debug === true ? 'on' : 'off';
        if (!schema || !tagname) {
            this.debug('参数有误:schema/tagname不能为空');
            if (/\?/.test(tagname)) {
                this.debug('参数有误:tagname不合法');
            }
            return false;
        }

        if (callback) {
            if (typeof callback !== 'function') {
                this.debug('参数有误:callback不是函数');
                return false;
            }
        }

        param       = typeof param === 'object' && isNaN(param.length) ? param : {};

        this.options = {
            schema                  : schema,
            tagname                 : tagname,
            param                   : param,
            callback                : callback,
            is_del_nativecallback   : is_del_nativecallback,
        }
        return true;
    }
    /**
     * * registCallbackFn : window下注册返回函数，等待native调用
     * 参数 
     * options={
     *    @callback     : function,     //string : 业务回调函数，收到native结果通过此函数传递结果
     * }
     * 返回:
     * 
     * */
    registCallbackFn() {
        let { callback, is_del_nativecallback } = this.options;
        if ( !callback ) return '';

        let callbackname = 'nativecallback_id_'+window.nativecallback_id++;
        window[callbackname] = (res) => {
            typeof callback === 'function' && callback(res, callbackname);
            if (is_del_nativecallback && callbackname) {
                delete window[callbackname];
            }
        }
        return callbackname;
    }
    /**
     * * paramToQuery : 对象转换为 query string
     * 参数
     * {
     *    @x : 'a', 
     *    @y : 'b'
     * }
     *
     * 返回:
     * x=a&y=b
     * */
    paramToQuery(obj={},callbackname) {
        let str = ''
        if(callbackname){
          str = 'callback=' + callbackname + '&callBack=' + callbackname + '&'
        }
        if(typeof obj == 'object'){
            for(let i in obj){
                if(typeof obj[i] != 'function' && typeof obj[i] != 'object'){
                    str += i + '=' + obj[i] + '&' ;
                }else if (typeof obj[i] == 'object' && isNaN(obj[i].length)){
                    str += i + '=' + encodeURIComponent(JSON.stringify(obj[i])) + '&' ;
                }
            }
        }
        return str.replace(/&$/g, '');
    }


    //调试输出
    debug(...ary){
        if (this.debugswitch === 'off') {
            return;
        }
        ary.unshift('[JsBridge]-');
        console.warn(...ary);
    }
};
 

let classjb = new JsBridge();
// export 兼容ios,android桥接
export const jsbridge = (options) => {
    if(classjb.formatOptions(options)) {
        classjb.bridgeWebview();    
    }
}
// export 兼容ios桥接
export const jsbridgeIos = (options) => {
    if(classjb.formatOptions(options)) {
        classjb.bridgeIosWebview();    
    }
}
// export 兼容android桥接
export const jsbridgeAndroid = (options) => {
    if(classjb.formatOptions(options)) {
        classjb.bridgeAndroidWebview();    
    }
}

export default jsbridge;








// WEBPACK FOOTER //
// ./node_modules/@kkmh/jsbridge/src/jsbridge.js